import { render, staticRenderFns } from "./roleGame.vue?vue&type=template&id=64917102&scoped=true&"
import script from "./roleGame.vue?vue&type=script&lang=js&"
export * from "./roleGame.vue?vue&type=script&lang=js&"
import style0 from "./roleGame.vue?vue&type=style&index=0&id=64917102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64917102",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64917102')) {
      api.createRecord('64917102', component.options)
    } else {
      api.reload('64917102', component.options)
    }
    module.hot.accept("./roleGame.vue?vue&type=template&id=64917102&scoped=true&", function () {
      api.rerender('64917102', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/roles/components/roleGame.vue"
export default component.exports